import axios from 'axios'
import { environment } from '../environment'

const apiServer = environment.API_URL + '/api'
export default axios.create({
  baseURL: apiServer
})
